import { pickBy, isEmpty, isNil } from "lodash";

export const omitEmptyValues = <T extends object>(obj: T) => {
  return pickBy(obj, (val) => !isEmpty(val));
};

export const omitNilValues = <T extends object>(obj: T) => {
  return pickBy(obj, (val) => !isNil(val));
};

export const hasProperty = <T extends object>(
  obj: T,
  prop: PropertyKey,
): prop is keyof T => {
  return Object.hasOwn(obj, prop);
};
